import React from 'react';
import useCenterlineAiStyles from './styles';
import { priceHint, RunOptionKind, rosterFor } from './core/run-options';
import { useCenterlineAi } from './CenterlineAiProvider';

/**
 * Model, thinking and steps (chat-ui-spec §2.6). Rendered only with
 * REACT_APP_CENTERLINE_AI_RUN_OPTIONS=true; the values load, persist and are sent either way.
 */

const PILLS: Array<{ kind: RunOptionKind; label: string; title: string; aria: string }> = [
  {
    kind: 'model',
    label: 'Model',
    title: 'Which model answers the next message',
    aria: 'Model for the next message',
  },
  {
    kind: 'effort',
    label: 'Thinking',
    title: 'How long the model may think before it answers',
    aria: 'How hard the model thinks',
  },
  {
    kind: 'steps',
    label: 'Steps',
    title: 'How many tool calls one answer may spend before it must answer from what it has',
    aria: 'How many tool calls the answer may spend',
  },
];

export default function RunOptionsBar() {
  const classes = useCenterlineAiStyles();
  const { state, actions } = useCenterlineAi();
  const { runOptions } = state;
  const { roster } = runOptions;
  const hint = roster ? priceHint(roster, runOptions) : null;

  return (
    <div className={classes.runBar}>
      {PILLS.map((pill) => (
        <label key={pill.kind} className={classes.runPill} title={pill.title}>
          <span>{pill.label}</span>
          <select
            aria-label={pill.aria}
            value={runOptions[pill.kind]}
            disabled={!roster}
            onChange={(e) => actions.setRunOption(pill.kind, e.target.value)}
          >
            {!roster ? (
              <option value="">{runOptions.status === 'failed' ? '' : 'Loading…'}</option>
            ) : (
              rosterFor(roster, pill.kind).map((o) => (
                <option key={o.id} value={o.id} title={o.blurb}>
                  {o.label}
                </option>
              ))
            )}
          </select>
        </label>
      ))}
      {hint ? (
        <span className={classes.runHint} title={hint.title}>
          {hint.text}
        </span>
      ) : null}
    </div>
  );
}
